(function(){
  "use strict";

  angular.module("modules.snapshotRange", []);

})();